<template>
  <div class="search_wrap">
    <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"/>
    <div class="search">
      <page-header class="search"></page-header>
      <div class="search_content">
        <div class="search_content_top">
          <el-select class="search_content_selectBox" v-model="value" placeholder="주요뉴스">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-input class="search_content_input" placeholder="검색어를 입력해주세요" v-model="input_keyword"
                    @keypress.native.enter="changeType(value)"></el-input>
          <button class="search_content_submitBtn" @click="changeType(value)"></button>
        </div>

        <board-empty-search-default-layout v-if="type === 'empty'"></board-empty-search-default-layout>

        <board-list-component v-if="type === 'business'" :boardType="`businessSearch`" :searchData="input_keyword"
        ></board-list-component>

        <board-list-component v-if="type === 'financial'" :boardType="`financialSearch`" :searchData="input_keyword"
        ></board-list-component>

        <board-list-component v-if="type === 'news'" :boardType="`newsSearch`" :searchData="input_keyword"
        ></board-list-component>

        <board-list-component v-if="type === 'donate'" :boardType="`donateSearch`" :searchData="input_keyword"
        ></board-list-component>

        <board-list-component v-if="type === 'album'" :boardType="`albumSearch`" :searchData="input_keyword"
        ></board-list-component>
      </div>
      <page-footer class="not_main"></page-footer>
    </div>
  </div>
</template>

<script>
import BoardListComponent from "@/components/board/BoardListComponent";
import util from "@/mixins/util";
import BoardEmptySearchDefaultLayout from "@/template/board/empty/BoardEmptySearchDefaultLayout";

export default {
  name: "Search",
  mixins: [],
  components: {BoardEmptySearchDefaultLayout, BoardListComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      options: [{
        value: 'business',
        label: '주요사업'
      }, {
        value: 'financial',
        label: '재무보고'
      }, {
        value: 'news',
        label: '뉴스'
      }, {
        value: 'donate',
        label: '나눔&배움'
      }, {
        value: 'album',
        label: '앨범'
      }],
      value: 'business',
      type: 'empty',
      input_keyword: '',

    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.dataSet();
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    changeType(val) {
      this.type = ''
      this.$nextTick(() => {
        this.type = val;
      })
      this.$router.replace(`${this.$route.path}?type=${val}`);
    },
    dataSet() {
      this.type = this.$route.query.type;
      this.input_keyword = this.$route.query.su;
      this.value = this.type;

      if (util.isEmpty(this.type)) {
        this.type = 'empty';
      }
      if (util.isEmpty(this.input_keyword)) {
        this.input_keyword = '';
      }
      if (util.isEmpty(this.value)) {
        this.value = 'business'
      }
    }

  },
  watch: {},
  meta: function () {
    return [
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
      },
    ]
  },
}
</script>

<style scoped>

</style>